'use client';
import 'client-only';

export function getLocalStorage(key: string, defaultValue?: any) {
  if (typeof window === 'undefined') return defaultValue;
  const value = localStorage?.getItem(key);

  if (value === null || value === undefined || value === 'undefined'){
    return defaultValue
  } else {
    return JSON.parse(value)
  }
}

export function setLocalStorage(key: string, value: any) {
  localStorage.setItem(key, JSON.stringify(value));
}
